import { useParentSize } from '@visx/responsive';
import { useEffect, useState } from 'react';

export function useParentWidthAndHeight() {
    const { parentRef, width } = useParentSize();

    const [parentHeight, setParentHeight] = useState(0);

    useEffect(() => {
        if (parentRef.current) {
            setParentHeight(parentRef.current.getBoundingClientRect().height);
        }
    }, [parentRef]);

    return {
        width,
        height: parentHeight,
        parentRef,
    };
}